import React, { Component } from 'react';

class YoutubeResultView extends Component {
    constructor(props) {
        super(props);
    }

    getYoutubeThumbnail() {
        return 'https://img.youtube.com/vi/' + this.props.result.videoId + '/1.jpg';
    }

    render() {
        return (
            <div onClick={this.props.onClick} className="youtube-result">
              <img className="youtube-result-thumbnail" src={this.getYoutubeThumbnail()}/>
              <div className="youtube-result-title">{this.props.result.title}</div>
            </div>
        );
    }
}
 
export default YoutubeResultView;
